import { Controller, type Control, type FieldPath, type FieldValues } from 'react-hook-form';

import { FieldDateInput } from './field-date-input';

interface FormFieldDateInputProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof FieldDateInput>, 'value' | 'onValueChange' | 'errors'> {
  control: Control<T>;
  name: FieldPath<T>;
}

export function FormFieldDateInput<T extends FieldValues>({ control, name, ...rest }: FormFieldDateInputProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FieldDateInput
          {...rest}
          value={field.value ?? ''}
          onValueChange={(v) => {
            field.onChange(v);
            field.onBlur();
          }}
          errors={fieldState.error ? [fieldState.error] : undefined}
        />
      )}
    />
  );
}
